/**
 * SEO Configuration
 *
 * This file contains patterns and limits for SEO generation.
 * For white-label applications, no hardcoded fallbacks are used.
 * Values are only added to meta tags if explicitly provided in SEO JSON or customer config.
 */

export interface SeoDefaults {
  /**
   * Image URL patterns for generating social media images
   * Use ${page} placeholder for page name
   * Leave empty if not using pattern-based images
   */
  imagePatterns: {
    og: string;
    twitter: string;
  };
  /**
   * Maximum length for meta descriptions (used for truncation)
   */
  descriptionMaxLength: number;
  /**
   * Maximum length for page titles (used for truncation)
   */
  titleMaxLength: number;
}

/**
 * SEO configuration
 * Contains only patterns and limits - no fallback values for white-label apps
 */
export const SEO_DEFAULTS: SeoDefaults = {
  // Image URL patterns (leave empty if not using pattern-based images)
  imagePatterns: {
    og: '',
    twitter: '',
  },

  // SEO limits for truncation
  descriptionMaxLength: 160,
  titleMaxLength: 60,
};

/**
 * Image dimensions for social media
 */
export const IMAGE_DIMENSIONS = {
  og: {
    width: '1200',
    height: '630',
  },
  twitter: {
    width: '1200',
    height: '630',
  },
};
